import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef, useEffect } from "react";
import apiResponse from "../../../../services/apiResponse";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
} from "reactstrap";
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import moment from "moment";
import IndexBloc from "./Blocs/IndexBlock";
import CreateBloc from "../../../Assesment/Managerial/Create/Blocs/CreateBloc";
import Select from "react-select";
import DatePicker from "../../../../helpers/ui/DatePicker";

import TableWFH from "./Components/TableWFH";
import "./custom_css.css";

const statusItems = [
  { value: '', label: "Semua" },
  { value: 1, label: "Sudah Mengisi" },
  { value: 0, label: "Belum Mengisi" },
]

var yearopt = [];
var tahunsekarang = new Date().getFullYear();
var lastsekarang = tahunsekarang - 10;
for (var i = tahunsekarang; i >= lastsekarang; i--) {
  yearopt.push({ value: i, label: i });
}

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

const IndexView = (props) => {
  let indexBloc = new IndexBloc();
  let createBloc = new CreateBloc();
  const [activeTab, setactiveTab] = useState("1");
  const activeRef = useRef();

  const [isLoadingSelectUnit, setIsLoadingSelectUnit] = useState(true);
  const [isLoadingEmployee, setIsLoadingEmployee] = useState(true);
  const [loading, setIsLoadingPopup] = useState(true);
  // Select
  const [optionUnits, setOptionUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedType, setSelectedType] = useState({
    value: "1",
    label: "Rekap Ketidakhadiran Perunit",
  });
  const [selectedEmployee, setSelectedEmployee] = useState("");

  // Filter
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [employeeOption, setEmployeeOption] = useState({ nip: "", nama: "" });
  const perorang = ["4", "10"];
  const perunit = ["1", "2", "3", "5", "6", "7", "8", "9", "11", "12"];
  const absensiRealtime = ["12"];
  const [status, setStatus] = useState(null)


  useEffect(() => {
    // get data unit
    indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            let options = reformatOptions(
              response,
              "work_unit_name_tabs",
              "hirarki"
            );
            setOptionUnits([
              {
                label: "Semua",
                value: "",
              },
              ...options,
            ]);
            setIsLoadingSelectUnit(false);
            setIsLoadingPopup(false)
          }
          break;
        case apiResponse.ERROR:
          setIsLoadingSelectUnit(false);
          // setIsLoadingPopup(false)
          break;
        default:
          break;
      }

    });

    indexBloc.fetchWorkUnit({});

    return () => {
      indexBloc.workUnitChannel?.unsubscribe();
    };
  }, []);

  let additionalFilter = {
    work_unit: selectedUnit?.value || "",
    work_unit_name: selectedUnit?.label || "",
    report_type: selectedType?.value || "",
    start_date: startDate,
    end_date: endDate,
    employee_uuid: selectedEmployee?.value || "",
    employee_wfh_status: status,
  };

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const exportExcel = () => activeRef.current.exportExcel();

  function handleButtonExport() {
    exportExcel();
  }

  function handleButtonSearch() {
    reloadActiveRef();
  }

  function handleButtonReset() {
    setSelectedUnit("");
    setTimeout(() => {
      reloadActiveRef();
    }, 300);
  }

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card style={{ height: "100%" }}>
              <CardBody>
                <div className="float-end">
                  {/* {
                                    (accessRole('create')) ?
                                        <Link to="home.html?create">
                                            <Button color="primary">New Sample</Button>
                                        </Link>
                                    : null
                                } */}
                </div>
                <CardTitle>Data Rekap WFH</CardTitle>
                <CardSubtitle className="mb-3">
                  Daftar Rekap WFH
                </CardSubtitle>
                <hr />
                {/* harusnya udah naik ini di dev */}
                <Row className="mb-3">
                  <label className="col-md-2">
                    Status Laporan
                  </label>
                  <Col md="3">
                    <Select name="status" options={statusItems} isAvForm={false} isClearable={true} onChange={(opt) => setStatus(opt ? opt.value : null)} value={statusItems.find(item => item.value === status)} />
                  </Col>
                </Row>
                {perunit.includes(selectedType.value) ? (
                  <>
                    <Row className="mb-3">
                      <label
                        htmlFor="gender"
                        className="col-md-2 col-form-label"
                      >
                        Unit Kerja
                      </label>
                      <Col md="4">
                        <Select
                          value={optionUnits.filter(
                            (option) => option.value === selectedUnit.value
                          )}
                          onChange={(s) => setSelectedUnit(s)}
                          required="required"
                          options={optionUnits}
                          isLoading={isLoadingSelectUnit}
                          classNamePrefix="select2-unit"
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {perorang.includes(selectedType.value) ? (
                  <>
                    <Row className="mb-3">
                      <label
                        htmlFor="fieldGender"
                        className="col-md-2 col-form-label"
                      >
                        Pegawai{" "}
                      </label>
                      <Col md="4">
                        <Select
                          value={
                            employeeOption
                              ? employeeOption.filter(
                                (option) =>
                                  option.value === selectedEmployee.value
                              )
                              : ""
                          }
                          onChange={(s) => setSelectedEmployee(s)}
                          required="required"
                          options={employeeOption}
                          isLoading={isLoadingEmployee}
                          classNamePrefix="select2-unit"
                          validate={{ required: { value: true } }}
                        // defaultValue={"1"}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                <Row className="mb-3">
                  <label className="col-md-2">
                    {(absensiRealtime.includes(selectedType.value) ? "Tanggal" : "Periode Mulai")}
                  </label>
                  <Col md="3">
                    <DatePicker
                      name="start_date"
                      isWeekday={false}
                      dateFormat="dd/MM/yyyy"
                      placeholder="Tanggal Mulai"
                      isAvForm={false}
                      onChange={(val) =>
                        setStartDate(moment(val).format("YYYY-MM-DD"))
                      }
                      defaultValue={startDate}
                    />
                  </Col>
                </Row>
                {absensiRealtime.includes(selectedType.value) ? "" : (
                  <Row className="mb-3">
                    <label className="col-md-2">Periode Akhir</label>
                    <Col md="3">
                      <DatePicker
                        name="end_date"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        placeholder="Tanggal Selesai"
                        isAvForm={false}
                        onChange={(val) =>
                          setEndDate(moment(val).format("YYYY-MM-DD"))
                        }
                        defaultValue={endDate}
                      />
                    </Col>
                  </Row>
                )}
                <Row className="mb-3">
                  <Col md="2"></Col>
                  <Col md="10">
                    {/* <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button> */}{" "}
                    {/* <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button> */}
                    <Button
                      color="success"
                      type="button"
                      onClick={() => {
                        handleButtonExport();
                      }}
                    >
                      Export Rekap WFH
                    </Button>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </Col>
                </Row>

                <hr />
                <div>
                  <TableWFH
                    ref={activeRef}
                    handleInactiveSuccess={reloadActiveRef}
                    additionalFilter={additionalFilter}
                  />

                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ConfirmAlert
        confirmTitle="Konfirmasi!"
        confirmInfo="Apakah anda yakin akan melakukan sinkronisasi data ini?"
        loadingTitle="Menyiapkan data..."
        loadingInfo="Tunggu beberapa saat"
        successTitle="Berhasil!"
        successInfo="Data berhasil diproses"
        failedTitle="Gagal!"
        failedInfo="Data gagal diproses"
        // showConfirm={confirm}
        showLoading={loading}
      // showSuccess={success}
      // showFailed={failed}

      // response={this.confirmResponse}
      />
    </Fragment>
  );
};

export default IndexView;
